module.exports = __webpack_public_path__ + "img/drink.2e7e8928.svg";